var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrincess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.049 23.677",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.015 11.544S-4.317-2.542 20.288 6.211l-.815-.962s-27.4-14.1-17.2 6.46Zm3.039 9.644.973 2.489h29.991l.977-2.489H6.054Zm34.975-9.644.745.165c10.2-20.562-17.2-6.46-17.2-6.46l-.807.962c24.6-8.753 17.265 5.333 17.265 5.333M24.459 2.551 22.028.001l-2.43 2.55 2.43 2.548Zm16.776 10.4-.68-.192s-13.692 9.672-18.527-4.672c-4.843 14.344-18.527 4.672-18.527 4.672l-.677.192 2.422 6.207h33.562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrincess);
export default __webpack_public_path__ + "static/media/princess.7c02f86aed4f07ff9f443f9e9ca5e8f8.svg";
export { ForwardRef as ReactComponent };